import React from 'react';
import PropTypes from 'prop-types';
import { FeedbackWrapper } from '../FeedbackWrapper';
import t from '@instructure/quiz-i18n/es/format-message';
export function NoResponse(_ref) {
  var className = _ref.className,
    correctAnswerLabel = _ref.correctAnswerLabel,
    responseHidden = _ref.responseHidden,
    richContent = _ref.richContent,
    status = _ref.status;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FeedbackWrapper, {
    correctAnswer: correctAnswerLabel,
    hiddenCorrectAnswerText: t('Correct answer: '),
    hiddenIncorrectAnswerText: t('Incorrect answer: '),
    richContent: richContent,
    status: status,
    userResponse: userResponseMessage(responseHidden, status)
  }));
}
function userResponseMessage(responseHidden, status) {
  if (responseHidden) {
    switch (status) {
      case 'correct':
        return t('(correct response not displayed)');
      case 'incorrect':
        return t('(incorrect response not displayed)');
      default:
        return t('(response not displayed)');
    }
  }
  return t('(no answer)');
}
NoResponse.propTypes = {
  className: PropTypes.string,
  correctAnswerLabel: PropTypes.string,
  responseHidden: PropTypes.bool,
  richContent: PropTypes.bool,
  status: PropTypes.oneOf(['correct', 'incorrect', 'unknown'])
};
NoResponse.defaultProps = {
  className: '',
  correctAnswerLabel: '',
  responseHidden: false,
  richContent: false,
  status: 'incorrect'
};
NoResponse.displayName = 'NoResponse';
export default NoResponse;